import { render, staticRenderFns } from "./DashboardCMTaxas.vue?vue&type=template&id=c5a56d70&scoped=true&"
import script from "./DashboardCMTaxas.vue?vue&type=script&lang=js&"
export * from "./DashboardCMTaxas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCMTaxas.vue?vue&type=style&index=0&id=c5a56d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a56d70",
  null
  
)

export default component.exports